export const tableConfig = {
  userInfo: {
    // Document Properties
    title: "Samson Auto Connectors Catalog",
    author: "Infokey",
    creator: "Infokey",
    producer: "Infokey",
    language: "en-US",
    pageLayout: "singlePage",
    coWebsite: "noblewiring.com",
    coEmail: "hi@noblewiring.com",
    headerText1: "HSN 85369090",
    headerText2: "w.e.f. June 2025",

    defaultImgIndexToShow: 0, // Example : 1 for no watermark, 0 for yes

    // Font Properties
    fontSource: "https://fonts.googleapis.com/css2?family=Montserrat",
    fontSourceBold: "https://fonts.googleapis.com/css2?family=Montserrat",

    // Page Properties
    pageSize: "A4",

    // Fields to render
    productNo: "part_no",
    description: "description",
    category: "category",
    image: "images",
  },
};
